import {
  HostEvent,
  HandshakeEvent,
  ConsumerEvent,
  HandshakeEvent_Deprecated,
} from './events';

import {
  AbstractHandshake,
  IOnMessage,
  IPostMessage,
} from './AbstractHandshake';
import { internalErrorMessage } from '../error';
import { hash } from '../hash';

export class ConsumerHandshake extends AbstractHandshake {
  #hostIsAlive = false;
  #memberId = `consumer-${hash()}`;

  constructor(postMessage: IPostMessage, onMessage: IOnMessage) {
    super(postMessage, onMessage);

    this.#initHandshake();

    const payload: ConsumerEvent = {
      type: HandshakeEvent.Ping,
    };

    postMessage(JSON.stringify(payload));
  }

  #initHandshake() {
    this.onMessage((event) => {
      try {
        const payload: HostEvent = JSON.parse(event.data);

        switch (payload.type) {
          case HandshakeEvent.Pong: {
            this.#onHostPing();
            break;
          }

          case HandshakeEvent.Port: {
            this.#onHostPort(payload.targetMemberId, event.ports?.[0]);
            break;
          }
        }
      } catch (e) {
        // skip unnecessary events
      }
    });
  }

  #onHostPing() {
    if (this.#hostIsAlive) {
      return;
    }

    this.#hostIsAlive = true;

    const payload: ConsumerEvent = {
      type: HandshakeEvent.RequestPort,
      memberId: this.#memberId,
    };

    this.postMessage(JSON.stringify(payload));
  }

  #onHostPort(targetMemberId: string, port?: MessagePort) {
    if (targetMemberId !== this.#memberId) {
      return;
    }

    if (!port) {
      throw new Error(internalErrorMessage('no port at consumer handshake'));
    }

    this.setActivePort(port);
  }
}
